/**
 * parcelamento.js (modificado para incluir cashback de 10%)
 *
 * - Calcula, para cada seção de produto:
 *    • Parcelamento (até 6×) considerando preço da variante × quantidade
 *    • Cashback de 10% do total (variante_price * quantidade)
 * - Atualiza dois elementos:
 *    • .product-installment (já existia) → “ou em 3x de R$ 110,00”
 *    • #ProductCashbackInfo-<sectionId> (novo) → “Ganhe R$ 11,00 de cashback”
 *
 * O ID do placeholder de cashback deve ser “ProductCashbackInfo-<sectionId>”,
 * e ele precisa estar no HTML (conforme passo 1).
 */

(function() {
  'use strict';

  console.log('▸ parcelamento.js carregado e executando');

  document.addEventListener('DOMContentLoaded', () => {
    console.log('▸ parcelamento.js: DOMContentLoaded → iniciando lógica de parcelamento + cashback');

    // 1) Seleciona todos os containers de parcelamento na página
    const installmentContainers = document.querySelectorAll(
      '.product-installment[data-installment-placeholder]'
    );
    console.log('▸ parcelamento.js: encontrado(s) container(s) de parcelamento →', installmentContainers);

    installmentContainers.forEach(container => {
      const sectionId = container.dataset.installmentPlaceholder;
      console.log(`▸ parcelamento.js (seção ${sectionId}): inicializando lógica`);

      // 2) Elementos essenciais
      const variantsJsonEl   = document.getElementById(`ProductVariantsJson-${sectionId}`);
      const minValueEl       = document.getElementById(`MinInstallmentValue-${sectionId}`);
      const cashbackEl       = document.getElementById(`ProductCashbackInfo-${sectionId}`);

      console.log(
        `▸ parcelamento.js (seção ${sectionId}): `,
        'ProductVariantsJson-', variantsJsonEl,
        '; MinInstallmentValue-', minValueEl,
        '; ProductCashbackInfo-', cashbackEl
      );

      if (!variantsJsonEl || !minValueEl) {
        console.warn(`parcelamento.js: faltou JSON ou MinInstallmentValue na seção ${sectionId}`);
        return;
      }
      if (!cashbackEl) {
        console.warn(`parcelamento.js: **não** encontrou #ProductCashbackInfo-${sectionId}`);
      }

      let variants;
      try {
        variants = JSON.parse(variantsJsonEl.textContent.trim());
      } catch (e) {
        console.error(`parcelamento.js: JSON inválido na seção ${sectionId}`, e);
        return;
      }

      const minInstallmentValue = Number(minValueEl.textContent.trim());
      if (isNaN(minInstallmentValue) || minInstallmentValue <= 0) {
        console.warn(`parcelamento.js: valor mínimo inválido em MinInstallmentValue-${sectionId}`);
        return;
      }

      // 3) Formatação de moeda
      function formatBRLFromCents(cents) {
        return (cents / 100).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }

      /**
       * 4) Calcula texto de parcelamento e cashback
       */
      function calcTexts(variantId, quantity) {
        console.log(
          `▸ parcelamento.js (seção ${sectionId}): calcTexts() chamado com variante=${variantId}, quantidade=${quantity}`
        );

        const v = variants.find(item => String(item.id) === String(variantId));
        if (!v) return { installmentText: '', cashbackText: '' };

        const priceCentsSingle = Number(v.price);
        if (isNaN(priceCentsSingle)) return { installmentText: '', cashbackText: '' };

        const totalPriceCents = priceCentsSingle * quantity;

        // Parcelamento
        let installmentText = '';
        if (totalPriceCents >= minInstallmentValue * 100) {
          const MAX_PARCELAS = 6;
          let numParc = Math.floor(totalPriceCents / (minInstallmentValue * 100));
          numParc = Math.min(numParc, MAX_PARCELAS);
          if (numParc >= 2) {
            const valorParcela = Math.floor(totalPriceCents / numParc);
            installmentText = `ou em ${numParc}x de ${formatBRLFromCents(valorParcela)}`;
          }
        }

        // Cashback de 10%
        const cashbackCents = Math.round(totalPriceCents * 0.10);
        const cashbackText  = formatBRLFromCents(cashbackCents);

        return { installmentText, cashbackText };
      }

      /**
       * 5) Atualiza o DOM para parcelamento e cashback
       */
      function updateDisplay(chosenVariantId) {
        console.log(`▸ parcelamento.js (seção ${sectionId}): updateDisplay() chamado variante=${chosenVariantId}`);

        // 5.1) Quantidade
        const qSelector     = `input[name="quantity"][form="product-form-${sectionId}"]`;
        const quantityInput = document.querySelector(qSelector);
        let quantity = 1;
        if (quantityInput) {
          const parsed = parseInt(quantityInput.value, 10);
          if (!isNaN(parsed) && parsed > 0) quantity = parsed;
          console.log(`▸ quantidade lida=${quantity}`);
        } else {
          console.warn(`parcelamento.js: não achou ${qSelector}`);
        }

        // 5.2) Calcula textos
        const { installmentText, cashbackText } = calcTexts(chosenVariantId, quantity);

        // 5.3) Injeta parcelamento
        container.textContent = installmentText;

        // 5.4) Injeta cashback
        const cbTextEl = document.querySelector(
          `#ProductCashbackInfo-${sectionId} .cashback-text`
        );
        if (cbTextEl) {
          cbTextEl.textContent = `Ganhe ${cashbackText} de cashback`;
          console.log(`▸ injetou cashback "Ganhe ${cashbackText} de cashback"`);
        } else {
          console.warn(
            `parcelamento.js: não encontrou .cashback-text em #ProductCashbackInfo-${sectionId}`
          );
        }
      }

      // Expor para testes console
      window.updateDisplay = updateDisplay;

      // Captura form e adiciona listeners
      const productForm = document.getElementById(`product-form-${sectionId}`);
      if (!productForm) {
        console.warn(`parcelamento.js: não encontrou form#product-form-${sectionId}`);
        return;
      }

      productForm.addEventListener('variant:change', e => {
        if (e.detail?.variant?.id) updateDisplay(e.detail.variant.id);
      });

      const quantityInputGlobal = document.querySelector(
        `input[name="quantity"][form="product-form-${sectionId}"]`
      );
      if (quantityInputGlobal) {
        quantityInputGlobal.addEventListener('input', () => {
          const hidden = productForm.querySelector('input[name="id"]');
          if (hidden?.value) updateDisplay(hidden.value);
        });
        quantityInputGlobal.addEventListener('change', () => {
          const hidden = productForm.querySelector('input[name="id"]');
          if (hidden?.value) updateDisplay(hidden.value);
        });
      }

      // Inicializa display
      const hiddenInput = productForm.querySelector('input[name="id"]');
      if (hiddenInput?.value) {
        updateDisplay(hiddenInput.value);
      } else {
        console.warn(
          `parcelamento.js: hidden input de variante não encontrado ou sem valor em form#product-form-${sectionId}`
        );
      }

      // Fallback MutationObserver
      if (hiddenInput) {
        new MutationObserver(muts => {
          muts.forEach(m => {
            if (m.attributeName === 'value') updateDisplay(hiddenInput.value);
          });
        }).observe(hiddenInput, { attributes: true });
      }
    });
  });
})();
